export default "__VITE_ASSET__96f81514__"